/**
 * The rail the records list is drawn on.
 *
 * One timeline, drawn top to bottom at a single x. Depth is carried by the
 * line's *weight*, not by a second line: the spine is thickest along the active
 * interval, narrows as the list descends into a group and again into a
 * subgroup, and thickens back on the way out.
 *
 * Cards all start at CONTENT_X, so the line is the only thing that moves.
 * Nothing is written to the left of the spine: the narrow strip there is for
 * marks only, which is why it is barely wider than one.
 *
 * Shared rather than private to `RecordsTimeline` because the rows that stand
 * *above* the scroll container — the new-record row, chiefly — have to land on
 * the same rail as the rows below it, and a second copy of these numbers is a
 * second copy that drifts.
 */

export const SPINE_X = 24;
export const CONTENT_X = 42;
/** Right inset of a record card — lines up with the level header's rule. */
export const CONTENT_R = 18;

/**
 * Half the gap between cards. Each row carries it top and bottom, so the
 * rhythm holds against a level header as evenly as against another card.
 */
export const ROW_PAD_Y = 3;
/**
 * Centre of a card's first title line, from the row's top edge: the row's own
 * padding, the card's 11px, and half a 14.5px/1.28 line. Everything drawn on
 * the spine hangs off this, so the marks meet the title rather than the box.
 */
export const TITLE_CY = ROW_PAD_Y + 20.5;
